import { defineMachine } from "../state-machine.js";
/** A release, refund, or split instruction to Airwallex, sent through the outbox and confirmed by webhook. */
export const instruction = defineMachine({
    name: "instruction",
    states: ["pending", "sent", "confirmed", "failed", "cancelled"],
    events: ["send", "confirm", "fail", "retry", "cancel"],
    initial: "pending",
    transitions: {
        pending: { send: "sent", cancel: "cancelled" },
        sent: { confirm: "confirmed", fail: "failed" },
        failed: { retry: "pending", cancel: "cancelled" },
        confirmed: {},
        cancelled: {},
    },
});
//# sourceMappingURL=instruction.machine.js.map